<template>
  <div>
    <slot v-if="useSlot"></slot>
    <div v-else>
      <div v-if="selectSchoolData.id" class="data-line">
        <span class="data-font">{{ selectSchoolData.name }}</span>
        <span class="change-btn" @click="handleOpenSchool">更换学校</span>
      </div>
      <div v-else class="class-add-btn" @click="handleOpenSchool">选择学校</div>
    </div>
    <Modal
      v-model="modalShow"
      :width="864"
      title="选择学校"
      :footer-hide="true"
      :closable="false"
      :mask-closable="false"
    >
      <Row :gutter="24">
        <Col span="12">
          <div class="search-line">
            <!-- <el-select v-if="showSelect" class="sremote" v-model="orgId" filterable remote clearable placeholder="请输入学校名称"
            :remote-method="handleSearchSchool" :loading="tableLoading">
            <el-option v-for="(item, index) in schoolList" :key="item.orgId" :label="item.name" :value="item.orgId">
              <div class="flex flexrow">
                {{ item.name }}
                <div class="refont">{{ item.areaName }}</div>
              </div>
            </el-option>
          </el-select> -->
            <Select
              v-model="orgId"
              filterable
              :remote-method="handleSearchSchool"
              :loading="tableLoading"
              @on-query-change="changequery"
            >
              <Option
                v-for="(item, index) in schoolList"
                :key="index"
                :value="item.orgId"
                :label="item.name"
              >
                <div class="flex flexrow">
                  {{ item.name }}
                  <div class="refont">{{ item.areaName }}</div>
                </div>
              </Option>
            </Select>
          </div>
        </Col>
      </Row>
      <div class="flex flexcol historyWrap">
        <div class="historyTitle">最近访问的单位</div>
        <div class="flex flexrow flexwrap hisScroll scroll-430 scroll-y-430">
          <div
            v-for="(item, index) in historyList"
            :key="index"
            class="flex flexac flexsb hisItem"
            @click="handleSureBtn(item)"
          >
            {{ item.name }}
            <Icon
              class="cursor-pointer"
              size="18"
              type="ios-close-circle"
              @click.stop="closeHistory(index)"
            ></Icon>
          </div>
          <div v-show="historyList.length == 0">暂无历史搜索记录~</div>
        </div>
      </div>
      <div class="modal-footer">
        <Button @click="handleCancleBtn">取消</Button>
        <Button type="primary" @click="handleSureBtn(false)">确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import operationAdmin from '@/request/operationAdmin/index.js';
import RadioOrCheckboxTable from '@c/Base/RadioOrCheckboxTable.vue';
import orderCenterApi from '@/request/orderCenter/index.js';
import M from 'minimatch';
import { mapState } from 'vuex';
export default {
  components: {
    RadioOrCheckboxTable
  },
  props: {
    useSlot: {
      type: Boolean,
      default: false
    }, // 是否是否使用插槽
    value: {
      type: Object,
      default: () => { }
    },
    isCombo: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      searchSchoolName: '', // 远程搜索学校名称
      modalShow: false,
      showSelect: false, // 选择框初始化
      orgId: '',
      schoolList: [], // 学校数据列表
      schoolPageInfo: {
        total: 0,
        pageSize: 10,
        pageNum: 1
      }, // 学校数据的page信息
      tableLoading: false,
      schoolListColumn: [
        {
          title: '学校名称',
          key: 'name',
          minWidth: 200
        },
        {
          title: '所属行政区',
          key: 'areaName',
          minWidth: 200
        }
      ], // 学校列表表格column
      portOrg: -1,
      firstGetData: false,
      historyList: [],
      historyObj: {},
      timer: null,
      // 最后请求时间戳
      lastTimeRequest: ''

    };
  },
  computed: {
    selectSchoolData: {
      get() {
        return this.value;
      },
      set(newVal) {
        this.$emit('input', newVal);
      }
    },
    ...mapState(['userInfo'])
  },
  created() {
    this.portOrg = Number(localStorage.getItem('portOrg'));
    console.log('selectSchoolData', this.selectSchoolData);
  },
  methods: {
    changequery(event) {
      if (!event) {
        this.handleSearchSchool('');
      }
    },
    handleSearchSchool(e) {
      // console.log("handleSearchSchool",e);
      // 添加防抖
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        this.searchSchoolName = e;
        this.schoolPageInfo = {
          total: 0,
          pageSize: 100,
          pageNum: 1
        };
        this.timer = null;
        this.lastTimeRequest = new Date().getTime();
        this.getSchoolListData(this.lastTimeRequest);
      }, 600);
    },
    handleOpenSchool() {
      this.orgId = null;
      this.schoolPageInfo = {
        total: 0,
        pageSize: 100,
        pageNum: 1
      };
      this.searchSchoolName = '';
      this.lastTimeRequest = new Date().getTime();
      this.getSchoolListData(this.lastTimeRequest);
      this.modalShow = true;
      setTimeout(() => { this.showSelect = true; }, 100);
    },
    // 获取学校列表数据
    async getSchoolListData(timestamp) {
      // 处理历史数据
      this.historyObj = localStorage.getItem('secrchHistory') ? JSON.parse(localStorage.getItem('secrchHistory')) : {};
      this.historyList = this.historyObj.hasOwnProperty(this.userInfo.orgId) ? this.historyObj[this.userInfo.orgId] : [];

      const yearTermCode = localStorage.getItem('yearTermCode') ? localStorage.getItem('yearTermCode').split(',') : [];
      const params = {
        pageNum: this.schoolPageInfo.pageNum,
        pageSize: this.schoolPageInfo.pageSize,
        orgType: 1,
        orgName: this.searchSchoolName,
        yearCode: yearTermCode.length ? yearTermCode[0] : '',
        termCode: yearTermCode.length ? yearTermCode[1] : ''
      };
      // this.searchSchoolName ? (params.searchStr = this.searchSchoolName) : '';
      this.isCombo ? params.officeAreaCode = '440114' : '';
      this.tableLoading = true;
      const res = await orderCenterApi.getWxOrgList(params);
      this.tableLoading = false;
      // 存在新的请求 之前的请求结果不作处理
      if (timestamp < this.lastTimeRequest) {
        return;
      }
      if (res.status === 200) {
        this.schoolList = res.message.list.map(item => {
          // ?
          item.id = item.orgId;
          item.name = item.orgName || item.name;
          return item;
        });
        this.schoolPageInfo.total = Number(res.message.total);
        !this.firstGetData ? this.$emit('firstLoadData', this.schoolList) : '';
        this.firstGetData = true;
      }
    },
    closeHistory(indexc) {
      this.historyObj[this.userInfo.orgId].splice(indexc, 1);
      this.historyList = this.historyObj[this.userInfo.orgId];
      localStorage.setItem('secrchHistory', JSON.stringify(this.historyObj));
    },
    // 缓存查询历史
    setHistory() {
      if (this.historyObj.hasOwnProperty(this.userInfo.orgId)) {
        // 是否之前搜索过这个学校
        let indexc = -1;
        this.historyObj[this.userInfo.orgId].map((item, index) => {
          if (item.orgId == this.selectSchoolData.orgId) {
            indexc = index;
          }
        });
        if (indexc > -1) {
          console.log('indexc', indexc);
          this.historyObj[this.userInfo.orgId].splice(indexc, 1);
        }
        this.historyObj[this.userInfo.orgId].unshift(this.selectSchoolData);
      } else {
        this.historyObj[this.userInfo.orgId] = [this.selectSchoolData];
      }
      localStorage.setItem('secrchHistory', JSON.stringify(this.historyObj));
    },
    handleSureBtn(history) {
      console.log('orgId', this.orgId);
      // 没有选择正确的学校
      if (!history && !this.orgId) {
        this.$Message.warning('请选择正确的学校！');
        return;
      }
      let curItem = {};
      if (history) {
        curItem = history;
      } else {
        this.schoolList.map((item, index) => {
          if (item.orgId == this.orgId) {
            curItem.id = item.orgId;
            curItem.name = item.name;
            curItem.orgId = item.orgId;
          }
        });
      }
      this.selectSchoolData = curItem;
      this.$nextTick(() => {
        console.log('this.selectSchoolData', this.selectSchoolData);
        this.$emit('postSchoolId', this.selectSchoolData.id);
        this.$emit('postSchoolRow', this.selectSchoolData);
        this.setHistory();
        this.modalShow = false;
        this.showSelect = false;
      });
    },
    handleCancleBtn() {
      this.modalShow = false;
      this.showSelect = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.historyWrap {
  padding: 10px 0 0px;
  min-height: 200px;
  box-sizing: border-box;

  .historyTitle {
    color: #a3b0c7;
    font-size: 14px;
    margin-bottom: 16px;
  }

  .hisScroll {
    max-height: 200px;
    // overflow-y: scroll;
  }

  .hisItem {
    background: #eff0f8;
    border-radius: 2px;
    width: 380px;
    box-sizing: border-box;
    padding: 0 16px;
    height: 40px;
    margin-right: 16px;
    margin-bottom: 16px;
    color: #606266;
    font-size: 14px;
    cursor: pointer;

    &:nth-child(2n) {
      margin-right: 0;
    }
  }
}

.search-line {
  margin-bottom: 16px;
  display: flex;

  .search-input {
    width: 160px;
    margin-right: 16px;
  }
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;

  button + button {
    margin-left: 8px;
  }
}

.refont {
  color: #a3b0c7;
  margin-left: 10px;
}

.sremote {
  width: 380px;
}
</style>

